import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setPage } from "../../store/helpers/helpersSlice";
import Card from "./Components/Card";
// import Pagination from "./Components/Pagination";
import PaginationTest from "./Components/PaginationTest";
import Loader from "../../Components/Loader/Loader";
import blogAPI from "../../utils/Api/blogAPI";
import UseSeo from "../../utils/customHooks/use-seo";

export default function Blog() {
  const dispatch = useDispatch();
  //! second variant

  const [items, setItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    dispatch(setPage("blog"));
  }, []);

  //! second variant

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await blogAPI.GetAllBlogPagination(currentPage);
        setItems(response.data.items);
        setTotalPages(response.data.totalPages);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const excerptList = items?.map((post) => {
    return post.content.split(" ").slice(0, 20).join(" ") + "...";
  });

  if (items === null) {
    return <Loader />;
  } else {
    return (
      <>
        <UseSeo
          title={"The Crazy Prints blog"}
          description={
            "News, views, case studies and ideas to help you along in the world of tech"
          }
          keywords={"printed portrait, Convert Photo, Anime Art"}
        />
        <div class="">
          <div class="bg-blogBg bg-cover h-[274px] flex justify-center text-center items-center">
            <div class="text-center">
              <h1 class="font-mainText text-regular text-[32px] leading-[36px]">
                The Crazy Prints blog
              </h1>
              <p class="font-textSec text-[18px] leading-[26px] text-white">
                News, views, case studies and ideas to help you along in the
                world of tech
              </p>
            </div>
          </div>
          <div>
            <div class="flex flex-wrap gap-[32px] px-[5%] pt-[100px] pb-[201px] items-center justify-center">
              {items.map((item, i) => (
                <Card
                  post={item}
                  i={i}
                  excerptList={excerptList}
                  key={Math.random(0, 1)}
                />
              ))}
            </div>
          </div>
          <div class="pb-[164px]">
            {/* <Pagination elements={blogList?.length} /> */}
            <PaginationTest
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </>
    );
  }
}
